/**
 * KAN-837: ошибки сохранения профиля менеджера (PATCH /managers/me/ и
 * work_hours в карточке менеджера) для показа под полями.
 * 400 {field: [msg]} -> {field: msg}; work_hours может прийти вложенным
 * объектом; {detail} и прочее уходит в поле "form" (общая строка над кнопкой).
 */
import { extractErrorMessage } from './extractErrorMessage';
import { workHoursErrorMessage } from './workHours';

export const FORM_ERROR_KEY = 'form';
export const SAVE_ERROR_FALLBACK = 'Не удалось сохранить';

export type ProfileErrors = Record<string, string>;

/** known: поля, которые форма показывает под собой; остальное в "form". */
export function profileErrorsFrom(err: unknown, known: readonly string[]): ProfileErrors {
  const data = (err as { response?: { data?: unknown } } | null)?.response?.data;
  const result: ProfileErrors = {};
  const rest: string[] = [];
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    for (const [field, value] of Object.entries(data as Record<string, unknown>)) {
      const msg = workHoursErrorMessage(value);
      if (!msg) continue;
      if (known.includes(field)) result[field] = msg;
      else rest.push(msg);
    }
  }
  if (rest.length > 0) result[FORM_ERROR_KEY] = rest.join('; ');
  if (Object.keys(result).length === 0) result[FORM_ERROR_KEY] = extractErrorMessage(err, SAVE_ERROR_FALLBACK);
  return result;
}
